import ServerProxy from '../../proxy/ServerProxy';
import { EventBus } from '../../main.js';

const adminGroups = {
    state: {
        // eslint-disable-next-line no-undef
        config:config,
        admins: [],
        internalUsers: [],
        serverProxy: new ServerProxy(),
    },
    getters: {
        getAdmins(state){
            return state.admins;
        },
        getInternalUsers(state){
            return state.internalUsers;
        }
    },
    actions: {       
        async getAdminGroups({ commit, state }){             
            const response = await new Promise((resolve, reject) => {
            state.serverProxy.serverRequest({
                url: `${state.config.rep_service_url}/admin/groups`,
                method: `GET`,
                needMask: true,
                headers: { 'Content-Type': `application/json` },
            })
            .then(resp => {
                resolve(resp);//changed response.data
                commit('setAdmins', resp);
            })
            .catch(err =>             
                reject(err)
            );
            });

            return response;
        }, 
        
        async getInternalUsers({ commit, state }){             
            const response = await new Promise((resolve, reject) => {
            state.serverProxy.serverRequest({
                url: `${state.config.rep_service_url}/admin/users/internal`,
                method: `GET`,  
                needMask: true,            
                headers: { 'Content-Type': `application/json` },
            })
            .then(resp => {
                resolve(resp);//changed response.data
                commit('setInternalUsers', resp);
            })
            .catch(err =>             
                reject(err)
            );
            });
            return response;
        }, 
        async saveAdmins({state }, entity){
            const url = `${state.config.rep_service_url}/admin/groups`;
            const response = await new Promise((resolve, reject) => {
                state.serverProxy.serverRequest({
                    url: url,
                    method: `POST`,
                    body:entity.entity,
                    needMask: true,
                    needResultDialog:true,
                    headers: {'Content-Type': 'multipart/form-data'},
                    callbackFunc:entity.callbackFunc
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err =>             
                    reject(err)
                );
                });
            console.log(response);//changed response.data
            EventBus.$emit("renderAdminGroups");            
            return response;
        },
    },
    mutations: {
        setAdmins(state, admins) {
            state.admins = admins;
        },
        setInternalUsers(state, internalUsers) {
            state.internalUsers = internalUsers;
        }   
    }
}
export default adminGroups;